import { useEffect, useState } from 'react'

const fontStyles = {
    color: '#FFF9AD',
    fill: '#FFF9AD',
    textAnchor: 'middle',
    fontFamily: 'Fira Sans',
    fontSize: '1.125em',
    fontWeight: '700',
}

const valueStyles = {
    ...fontStyles,
    fontSize: '3em',
}

interface IProps {
    value: number
    title?: string
}

const StreakBanner: React.FC<IProps> = ({ value, title }) => {
    const [displayedValue, setDisplayedValue] = useState(0)
    const animationDuration = 1000 // in milliseconds

    useEffect(() => {
        let start: number

        const step = (timestamp: number) => {
            if (start === undefined) {
                start = timestamp
            }

            if (value > 0) {
                const elapsed = timestamp - start
                const newDisplayedRating =
                    displayedValue + Math.round(((value - displayedValue) * elapsed) / animationDuration)
                setDisplayedValue(newDisplayedRating)

                if (elapsed < animationDuration) {
                    window.requestAnimationFrame(step)
                } else {
                    setDisplayedValue(value)
                }
            }
        }

        requestAnimationFrame(step)
    }, [value])

    return (
        <svg width="244" height="122" viewBox="0 0 244 122" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_43401_40587)">
                <animateTransform
                    attributeName="transform"
                    type="translate"
                    from="0,-122"
                    to="0,0"
                    dur="300ms"
                    fill="freeze"
                />
                <path
                    opacity="0.4"
                    d="M2.27002 6.09V119.44C2.27002 120.63 3.32002 121.54 4.49002 121.39L122 105.65L239.51 121.39C240.69 121.55 241.73 120.63 241.73 119.44V6.09H2.27002Z"
                    fill="black"
                />
                <path
                    d="M0 0V115.49C0 116.7 1.07 117.63 2.27 117.47L122 101.43L241.73 117.47C242.93 117.63 244 116.7 244 115.49V0H0Z"
                    fill="black"
                />
                <path
                    d="M5.87012 0V110.6L122 95.11L238.13 110.6V0"
                    stroke="#FFF9AD"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                />
                <style>
                    {`
                        @keyframes fontGrow {
                            0% { font-size: 3em; fill: #FFF9AD; }
                            20% { font-size: 4em; fill: #FFFFFF; }
                            80% { font-size: 4em; fill: #FFFFFF; }
                            100% { font-size: 3em; fill: #FFF9AD; }
                        }
                        @keyframes titleColor {
                            0% { fill: #FFF9AD; }
                            20% { fill: #FFFFFF; }
                            80% { fill: #FFFFFF; }
                            100% { fill: #FFF9AD; }
                        }
                    `}
                </style>
                <text
                    x="50%"
                    y="30%"
                    dominantBaseline="middle"
                    {...valueStyles}
                    style={{
                        animation: 'fontGrow 2s 1s forwards',
                    }}
                >
                    <animate attributeName="opacity" values="0;0;1" dur="1s" repeatCount="1" />
                    {displayedValue}
                </text>
                <text
                    x="50%"
                    y="60%"
                    dominantBaseline="middle"
                    {...fontStyles}
                    style={{
                        animation: 'titleColor 2s 1s forwards',
                    }}
                >
                    <animate attributeName="opacity" values="0;0;1" dur="1s" repeatCount="1" />
                    {title ? title.toUpperCase() : ''}
                </text>
            </g>
            <defs>
                <clipPath id="clip0_43401_40587">
                    <rect width="244" height="121.4" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

StreakBanner.displayName = 'StreakBanner'

export default StreakBanner
